import { TagSetPage } from "./TagSetPage";
interface CreateTagSetPageProps {
    spaceId: string;
}
export function CreateTagSetPage({ spaceId }: CreateTagSetPageProps) {
    return <TagSetPage spaceId={spaceId} create/>;
}
